import React, { Fragment, useState } from "react";
import { useQuery } from '@tanstack/react-query';

import { getCarerMint, createMemoryform } from "../services/api";
import MemoryformForm from "./MemoryformForm";
import MemoryformMint from "./MemoryformMint";

import "../styles/Memoryform.css";

const Memoryform = ({ address, setMinted }) => {
  const [metadata, setMetadata] = useState(null);
  const [lengthErr, setLengthErr] = useState(false);
  const [msg, setMsg] = useState("");

  const [rand] = useState(Math.floor(Math.random() * 100) + 1)

  const { data, error, isFetching } = useQuery({
    queryKey: [`getCarerMint-${address}`],
    queryFn: async () => getCarerMint(address.toLowerCase())
  })

  const maxLength = 501;

  function pad(strings, max) {
    let s = []
    if (!strings || Object.keys(strings).length === 0) {
      return "";
    }
    let result = "";
    s = Object.keys(strings).map((key) => {
      if (key.startsWith("text")) {
        if (strings[key].trim() === "") { return undefined; }
        return `Lifeform #${key.slice(5)} was named ${strings[key].trim()}`
      } else if (key === "approve") {
        return undefined;
      } else {
        return strings[key].trim();
      }
    })
    s = s.filter((str) => str !== undefined);
    const baseLength = s.reduce((acc, str) => acc + str.length, 0);
    const paddingLength = max - baseLength;
    if (paddingLength <= 0) {
      setLengthErr(true);
      return s.join(" ");
    } else {
      setLengthErr(false);
    }
    const averagePaddingLength = Math.floor(paddingLength / (s.length - 1));
    for (let i = 0; i < s.length; i++) {
      // Add the current string to the result
      result += s[i];
      // Check if this is the last string. If not, add padding
      if (i < s.length - 1) {
        const pl = Math.floor(averagePaddingLength);
        const padding = " ".repeat(pl);
        result += padding;
      } else {
        const end = max - result.length;
        console.log(end)
        result += " ".repeat(end);
      }
    }
    return result;
  }

  const onChange = (e, err) => {
    // e.preventDefault();
    if (e && Object.keys(err).length === 0) {
      let m = pad(e, maxLength+rand);
      document.querySelector("textPath").innerHTML = m//.textPath. = m;
      setMsg(m);
    }
  }

  const onSubmit = async (data) => {
    try {
      const response = await createMemoryform({
        address: address.toLowerCase(),
        msg,
        approve: data.approve,
      })
      setMetadata(response.data.data)
    } catch (err) {
      console.log(err)
    }
  }
    
  return (
    <div className="panelWide">
      {isFetching && !error ? <p>Loading ...</p> : 
        data && !error ? (
          <div className="container">
            <div id="memoryImg"  dangerouslySetInnerHTML={{ __html: data.svg }} />
            <div className="half">
              { metadata ? <MemoryformMint setMinted={setMinted} data={metadata} /> : (
                <Fragment>
                <MemoryformForm
                  lengthErr={lengthErr}
                  data={data}
                  onChange={onChange}
                  prompt="Do you want to share any other memories of your lifeforms?"
                  onSubmit={onSubmit}/>
                </Fragment>
              )}
            </div>
          </div>
        ) : <p>There was an error loading your memoryform</p>
      }
    </div>
  );
}

export default Memoryform;
